// extracted by mini-css-extract-plugin
module.exports =  {"path":"path__Y9l7b"};